import React, { useMemo } from 'react'
import { H2, P } from '@berlitz/globals/lib/components/typography'
import { Section } from '@berlitz/globals/lib/components/layout'
import resizeImage from '@berlitz/max-utils/lib/resizeImage'
import ArrowIcon from '@berlitz/streamline-icons/lib/bold/52-Arrows-Diagrams/01-Arrows/ArrowButtonRight'
import htmlCheck from '@berlitz/max-utils/lib/htmlCheck'
 const getBackgroundColor = (colorKey = 'White') => {
    const colorMap = {
      Blue: 'brandPrimary',
      'Brand Primary': 'brandPrimary',
      'Brand Secondary': 'brandSecondary',
      Charcoal: 'ui05',
      Green: 'brandSecondary',
      'Light Gray': 'ui01',
      'Medium Gray': 'ui02',
      Purple: 'purple',
      White: 'ui00',
    }
  
    return colorMap[colorKey] || colorMap['White']
  }

import {
  BannerWrapper,
  ImageColumn,
  DetailColumn,
  Image,
  BannerLink,
  ArrowIconWrapper,
  BannerPromoTitle,
} from './style'
const ConditionalWrapper = ({ condition, wrapper, children }) => {
    return condition ? wrapper(children) : children
  }
  
const SliceBannerPromotion = ({ primary }) => {    
    const {
        background_color,
        section_background_color,
        banner_subtitle,
        banner_title,
        image,
        internal_link,
        external_link,
        disablePaddingTop,
    } = primary || {}; 
    const backgroundColor = useMemo(
        () =>
          getBackgroundColor(
            background_color === 'Brand Secondary' ? 'Purple' : background_color
          ),
        [background_color]
      )
      const sectionBackgroundColor = useMemo(
        () =>
          getBackgroundColor(
            section_background_color === 'Brand Secondary'
              ? 'Purple'
              : section_background_color
          ),
        [section_background_color]
      )
    const bannerLinkUrl = internal_link?.url || external_link?.url
    const targetAttr = external_link ? '_blank' : '_self'
    const darkBackgrounds = ['brandPrimary', 'ui05', 'purple', 'charcoal']
    const hasDarkBackground = darkBackgrounds.includes(backgroundColor)

  return (
    <Section
            backgroundColor={sectionBackgroundColor}
            disablePaddingTop={disablePaddingTop}
            >
             <BannerWrapper backgroundColor={backgroundColor}>
        <ConditionalWrapper
          condition={bannerLinkUrl}
          wrapper={children => (
            <BannerLink
              href={bannerLinkUrl}
              target={targetAttr}
              backgroundColor={backgroundColor}
            >
              {children}
            </BannerLink>
          )}
        >
          <DetailColumn backgroundColor={backgroundColor}>
            {React.createElement(banner_subtitle?.length > 90 ? P : H2, {
              as: 'p',
              color: backgroundColor === 'ui00' ? 'brandPrimary' : null,
              inverse: hasDarkBackground,
              fontWeight: 'bold',
              size: banner_subtitle.text?.length > 90 ? 'lg' : null,
              'data-key': 'banner-promo-subtitle',
              dangerouslySetInnerHTML: { __html: banner_subtitle.text },
            })}
            <P
              size="lg"
              fontWeight="bold"
              highlight={'secondary'}
              inverse={hasDarkBackground}
              disableMargin
              data-key="banner-promo-title"
            >
              {htmlCheck.test(banner_title.text) ? (
                <BannerPromoTitle dangerouslySetInnerHTML={{ __html: banner_title.text }} />
              ) : (
                <BannerPromoTitle>{banner_title.text}</BannerPromoTitle>
              )}
              {bannerLinkUrl && (
                <ArrowIconWrapper>
                  <ArrowIcon size="xs" color="ui00" />
                </ArrowIconWrapper>
              )}
            </P>
          </DetailColumn>
          {image?.url && (
            <ImageColumn backgroundColor={backgroundColor}>
              <Image
                loading="lazy"
                alt={image?.alt || ''}
                src={resizeImage(image?.url, 320, 320)}
              />
            </ImageColumn>
          )}
        </ConditionalWrapper>
      </BannerWrapper>
    </Section>
  )
};

export default SliceBannerPromotion;
